import React from "react";
import PropTypes from "prop-types";

const ShowCaseLoading = ({ title }) => {
    return (
        <div className="banner">
            <span>{title}</span>
        </div>
    );
};

ShowCaseLoading.defaultProps = {
    title: "LabX.com Showcase"
};

ShowCaseLoading.propTypes = {
    title: PropTypes.string
};

export default ShowCaseLoading;
